import axios from 'axios';
import getApiBaseUrl from '../GetServer';

export const changeChatBotStatus = async (idChatBot: number, status: number) => {
  try {
    const baseUrl = getApiBaseUrl();
    const endpoint = `${baseUrl}dash/change-of-status`;

    const token = localStorage.getItem("token");
    if (!token) {
      throw new Error("Token no disponible");
    }

    const response = await axios.post(
      endpoint,
      {
        idChatBot,
        status
      },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error al cambiar estado:', error);
    throw error;
  }
};
